import { LeadType } from '../_enums/lead-type.enum';

export type CustomerSupportsOfPartnerRequest = {
  partnerId: string;
};

export type CustomerSupportsOfPartnerResponse = {
  error: string;
  status: string;
  data: {
    listCustomerSupports: CustomerSupportDetails[];
  };
};

export type CustomerSupportDetails = {
  customerSupportPartnerId: string;
  adminId: string;
  firstName: string;
  lastName: string;
};

export type AssignCustomerSupportRequest = {
  customerSupportId: string;
  partnerId: string;
};

export type AssignCustomerSupportResponse = {
  error: string;
  status: string;
  data: null;
};

export type DeleteCustomerSupportResponse = {
  error: string;
  status: string;
  data: null;
};

export type CustomerSupportAssignableEntities =
  | 'lead'
  | 'proposal'
  | 'claim'
  | 'insurance-flow'
  | 'cancellation';

export const getCustomerSupportAssignableEntityFromLeadType = (
  value: LeadType
): CustomerSupportAssignableEntities => {
  if (value === LeadType.INSURANCE) return 'insurance-flow';
  if (value === LeadType.CLAIM) return 'claim';
  if (value === LeadType.CANCELLATION) return 'cancellation';

  return 'proposal';
};
